import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-599c53e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "background custom-dark overflow-hidden" }, null, -1))
const _hoisted_2 = { class: "w-screen h-screen flex flex-col px-12" }
const _hoisted_3 = { class: "pt-32 pb-20" }
const _hoisted_4 = { class: "hide-things text-6xl font-bold text-text-white text-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "show-things text-6xl font-bold text-text-white text-center" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "overflow-hidden custom-container rounded-2xl z-10 flex flex-wrap text-center bg-background-medium justify-center relative" }
const _hoisted_9 = { class: "text-text-white font-bold text-4xl mb-10" }
const _hoisted_10 = { class: "circle-wrapper" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { class: "watch__border-animated" }, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "200",
    cy: "200",
    r: "190"
  })
], -1))
const _hoisted_12 = { class: "inner-circle rounded-full flex items-center justify-center" }
const _hoisted_13 = { class: "text-text-white text-8xl font-bold" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "stroke-current"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M2.8125 19.0625L15.3125 31.5625L37.8125 9.0625",
    "stroke-width": "4",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "w-full absolute bottom-0 hide-things" }
const _hoisted_17 = /*#__PURE__*/_createStaticVNode("<svg width=\"460\" height=\"822\" viewBox=\"0 0 230 411\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" class=\"ticket\" data-v-599c53e6><rect width=\"230\" height=\"411\" fill=\"white\" data-v-599c53e6></rect><circle cx=\"22.5\" cy=\"399.5\" r=\"5.5\" fill=\"#212121\" data-v-599c53e6></circle><circle cx=\"87.5\" cy=\"399.5\" r=\"5.5\" fill=\"#212121\" data-v-599c53e6></circle><circle cx=\"109.5\" cy=\"399.5\" r=\"5.5\" fill=\"#212121\" data-v-599c53e6></circle><circle cx=\"172.5\" cy=\"399.5\" r=\"5.5\" fill=\"#212121\" data-v-599c53e6></circle><rect x=\"45\" y=\"394\" width=\"22\" height=\"11\" rx=\"5.5\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"136\" y=\"394\" width=\"22\" height=\"11\" rx=\"5.5\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"191\" y=\"394\" width=\"22\" height=\"11\" rx=\"5.5\" fill=\"#212121\" data-v-599c53e6></rect><path d=\"M66.5518 271.234V246.514H90.8219V271.234H66.5518Z\" stroke=\"#212121\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-599c53e6></path><path d=\"M141.138 271.234V246.514H166V271.234H141.138Z\" stroke=\"#212121\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-599c53e6></path><path d=\"M67.7354 188.246V172.354H93.1894\" stroke=\"#212121\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-599c53e6></path><path d=\"M110.948 170V188.834M142.322 172.943V196.486H165.408V172.943H142.322Z\" stroke=\"#212121\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-599c53e6></path><path d=\"M64.1836 227.091H78.3905V215.909H89.6376V194.131H101.477M107.988 216.497H121.011V228.857H154.753M166 228.857H154.753M154.753 228.857V213.554M121.011 244.749V258.874M121.011 273V258.874M121.011 258.874H107.396\" stroke=\"#212121\" stroke-width=\"8\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-599c53e6></path><rect x=\"63\" y=\"200.606\" width=\"9.47126\" height=\"9.41714\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"94.9658\" y=\"232.389\" width=\"9.47126\" height=\"9.41714\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"116.275\" y=\"190.011\" width=\"9.47126\" height=\"9.41714\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"128.115\" y=\"200.606\" width=\"9.47126\" height=\"9.41714\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" width=\"62\" height=\"74\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"99\" y=\"66\" width=\"83\" height=\"8\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" y=\"101\" width=\"184\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" y=\"117\" width=\"184\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" y=\"133\" width=\"184\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" y=\"347\" width=\"184\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"23\" y=\"363\" width=\"184\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"65\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"83\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"101\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"119\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"137\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect><rect x=\"155\" y=\"294\" width=\"12\" height=\"4\" fill=\"#212121\" data-v-599c53e6></rect></svg>", 1)
const _hoisted_18 = { class: "show-things text-left pl-20 w-full justify-between flex pr-20 flex-col items-center py-20" }
const _hoisted_19 = { class: "font-light mb-5 text-4xl px-20 text-center whitespace-pre-line" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/box-map.png",
  class: "w-9/12"
}, null, -1))
const _hoisted_21 = { class: "w-full flex justify-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "92",
  height: "62",
  viewBox: "0 0 46 31",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-4 mt-0.5"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M44.5 15.5H1.5",
    stroke: "#212121",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M15.5 1.5L1.5 15.5L15.5 29.5",
    stroke: "#212121",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, [
          _createTextVNode(_toDisplayString(_ctx.t('intro.screen-3.title-1')), 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-3.title-2')), 1)
        ]),
        _createElementVNode("h1", _hoisted_6, [
          _createTextVNode(_toDisplayString(_ctx.t('intro.screen-3.title-3')), 1),
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-3.title-4')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", {
          class: _normalizeClass(`
          hide-things
          bg-stories-${_ctx.selectedStory.color}
          w-full
          py-10
          rounded-2xl
          flex
          justify-center
          items-center
          flex-col
          h-96
        `)
        }, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.selectedStory.title), 1),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getNumberByColor(_ctx.selectedStory.color)), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(`
              checkmark
              bg-text-white
              rounded-full
              w-16
              h-16
              flex
              items-center
              justify-center
              text-stories-${_ctx.selectedStory.color}
            `)
            }, _hoisted_15, 2)
          ])
        ], 2),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", {
            class: _normalizeClass(`ticket-box relative bg-stories-${_ctx.selectedStory.color} w-full h-64 -ml-32`)
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t('intro.screen-3.info')), 1),
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "flex text-3xl font-light bg-text-white text-text-black py-7 px-10 rounded-2xl shadow-1xl",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.naarStart && _ctx.naarStart(...args)))
            }, [
              _hoisted_22,
              _createTextVNode(" " + _toDisplayString(_ctx.t('intro.screen-3.button-back')), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}